'use client'
import ReactDOMServer from 'react-dom/server'

import CustomMarker from '@/components/map/components/naverMap/components/CustomMarker'
import NaveMapController from '@/components/map/components/naverMap/components/MapController'
import useParkinglotMapViewModel from '@/components/myTicket/components/map/viewModel'

import Shared from '@/shared'

interface ParkinglotMapProps {
  lat: number
  lng: number
}

function ParkinglotMap({ lat, lng }: ParkinglotMapProps) {
  const customLocationIcon = ReactDOMServer.renderToString(<CustomMarker.ParkinglotPositionMarker />)
  const currentMarker = ReactDOMServer.renderToString(<CustomMarker.CurrentPositionMarker />)

  const { states } = useParkinglotMapViewModel({ customLocationIcon, lat, lng })

  const mapLayoutPositions = Shared.States.useMapLayoutPositions((state) => state.positions)

  return (
    <div className="relative flex flex-1">
      <div className="absolute h-full w-full" style={{ padding: `0 ${mapLayoutPositions.paddingX}px` }}>
        <div className="relative h-full w-full">
          <NaveMapController.ZoomLevelControlButton mapRef={states.naverMapRef} />
          <NaveMapController.ParkinglotLocationButton map={states.naverMapRef} latitude={lat} longitude={lng} />
          <NaveMapController.CurrentLocationButton map={states.naverMapRef} locationMarker={currentMarker} />
        </div>
      </div>
      <div id="map" style={{ width: '100%', height: '100%' }} />
    </div>
  )
}

export default ParkinglotMap
